import React from 'react';
import '../components/header.css';
import './home.css';
import Sec10 from '../components/sec10';
import Footer from '../components/footer';

const Register = () => {
    return ( <>
    <div className="home-page">
    <Sec10 />
    <Footer />
    </div>
    </> );
}
 
export default Register;